import { $fetch } from "ofetch";
import { parseCookies } from "h3";

const CSRF_COOKIE = "XSRF-TOKEN";
const CSRF_HEADER = "X-XSRF-TOKEN";

export const $larafetch = $fetch.create({
  credentials: "include",
  async onRequest({ request, options }) {
    const { backendUrl, frontendUrl } = useRuntimeConfig().public;
    const event = typeof useEvent === "function" ? useEvent() : null;

    let token = event
      ? parseCookies(event)[CSRF_COOKIE]
      : useCookie(CSRF_COOKIE).value;

    // on client initiate a csrf request and get it from the cookie set by laravel
    if (import.meta.client && options.method && ["post", "delete", "put", "patch"].includes(options.method.toLowerCase())) {
      token = await initCsrf();
    }

    let headers: any = {
      accept: "application/json",
      "Accept-Language": useNuxtApp().$i18n.locale.value,
      ...options?.headers,
      ...(token && { [CSRF_HEADER]: token }),
    };

    if (import.meta.server) {
      const cookieString = event
        ? event.headers.get("cookie")
        : useRequestHeaders(["cookie"]).cookie;

      headers = {
        ...headers,
        ...(cookieString && { cookie: cookieString }),
        referer: frontendUrl,
      };
    }

    options.headers = headers;
    options.baseURL = backendUrl;
  },
  // @ts-ignore
  async onResponseError({ response }) {
    // @ts-ignore
    const status = response.status;

    if ([400, 422, 429].includes(status)) {
      toastError(response);
    }

    if ([500, 404, 403].includes(status)) {
      // @ts-ignore
      return showError({ statusCode: status, statusMessage: response?.message });
    }
  },
});

function toastError(error: any) {
  const toast = useToast();

  toast.add({
    title: error?._data?.message,
    color: "red",
    icon: "i-approved-warning",
  });
}

async function initCsrf() {
  const { backendUrl } = useRuntimeConfig().public;
  const existingToken = useCookie(CSRF_COOKIE).value;

  if (existingToken) return existingToken;

  await $fetch("/sanctum/csrf-cookie", {
    baseURL: backendUrl,
    credentials: "include",
  });

  return useCookie(CSRF_COOKIE).value;
}
